import { render } from "./PagePanel.vue?vue&type=template&id=24b408ca&scoped=true"
import script from "./PagePanel.vue?vue&type=script&lang=js"
export * from "./PagePanel.vue?vue&type=script&lang=js"

import "./PagePanel.vue?vue&type=style&index=0&id=24b408ca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b408ca"]])

export default __exports__